//
// Copyright (c) 2025 Comcast
//

const it = {
  'translation': {
    'common': {
      'update': 'Aggiorna',
      'cancel': 'Annulla',
      'submit': 'Submit (it)',
      'confirm': 'Confirm (it)',
      'confirmChanges': 'Confirm Changes (it)',
      'save': 'Save (it)',
      'send': 'Send (it)',
      'add': 'Add (it)',
      'areYouSure': 'Are you sure? (it)',
      'yes': 'Si',
      'no': 'No',
      'copy': 'Copy (it)',
      'close': 'Close (it)',
      'enabled': 'enabled (it)',
      'disabled': 'disabled (it)',
      'notSelected': 'NOT SELECTED',
      'breadcrumbTicketingSystems': 'Ticketing Systems (it)',
      'breadcrumbTicketingSystemsByPartner': '{{partnerName}} Ticketing Systems (it)',
      'breadcrumbTicketingSystem': 'Sistema di Ticketing',
      'breadcrumbTicketEdit': 'Modifica Ticket',
      'breadcrumbTicketClone': 'Clona Ticket',
      'breadcrumbTicketCreate': 'Crea Ticket',
      'breadcrumbTicketRequests': 'Ticket Requests',
      'breadcrumbTicketsSearchResults': 'Search Results (it)',
      'breadcrumbTicketProviders': 'Ticket Providers (it)',
      'breadcrumbTicketProviderTicketBoards': 'Provider Ticket Boards (it)',
      'breadcrumbPartners': 'Partners (it)',
      'breadcrumbPartner': 'Partner (it)',
      'breadcrumbOauthApps': 'Oauth Apps (it)',
      'breadcrumbProviders': 'Providers (it)',
      'breadcrumbSatClients': 'SAT Clients (it)',
      'breadcrumbSatSecrets': 'SAT Secrets (it)',
      'breadcrumbStatusCollections': 'Status Collections (it)',
      'breadcrumbStatusCollection': 'Status Collection (it)',
      'breadcrumbPartnerStatuses': 'Partner Statuses (it)',
      'breadcrumbMimeTypeCollections': 'Mime Type Collections (it)',
      'breadcrumbMimeTypeCollection': 'Mime Type Collection (it)',
      'breadcrumbQueries': 'Queries (it)',
      'breadcrumbMimeTypes': 'MIME Types (it)',
      'breadcrumbSharedFieldsMaps': 'Shared Fields Maps (it)',
      'breadcrumbColumns': 'Columns (it)',
      'breadcrumbReleaseNotes': 'Release Notes (it)',
      'breadcrumbReleaseNotesAdd': 'Add New Release (it)',
      'breadcrumbReleaseNotesEdit': 'Edit {{releaseName}} Release (it)',
      'breadcrumbUserProfile': 'User Profile (it)',
      'breadcrumbProviderCredentials': 'Provider Credentials (it)',
      'periodMin': 'min (it)',
      'periodHour': 'h (it)',
      'periodDay': 'day (it)',
      'noChartData': 'no data (it)',
      'noTableData': 'no data (it)',
      'noTableDataWithFilterOrSearch': 'nothing found. try searching for something else or apply other filters (it)',
      'success': 'success (it)',
      'failed': 'failed (it)',
      'uploadError': 'UPLOAD ERROR (it)',
      'fileUploadtimeOut': 'File Upload Timed Out (it)',
      'requestTimeOut': 'Request Timed Out (it)',
      'multiSelectItemCount_one': '{{count}} item (it)',
      'multiSelectItemCount_other': '{{count}} items (it)',
      'inheritedFromProvider': 'INHERITED FROM PROVIDER (it)',
      'typeHere': 'Type here (it)',
      'requiredField': 'required field (it)',
      'partner': 'partner (it)',
      'email': 'email (it)',
      'userName': 'user name (it)',
      'description': 'description (it)',
      'createdAt': 'created at (it)',
      'updatedAt': 'updated at (it)',
      'downloadCsv': 'Scarica CSV',
      'exportToCsv': 'Esporta in CSV',
      'moreLink': 'More (it)',
      'tooltipCopy': 'Copy (it)',
      'tooltipCopyLink': 'Copy Link (it)',
      'tooltipCopied': 'Copied! (it)',
      'tooltipShowMore': 'Show More (it)',
      'tooltipDownload': 'Download (it)',
      'lastReleaseNoteNotification': 'Relay {{version}} version was released. Please check release notes (it)',
      'goToReleaseNotes': 'Go to Release Notes (it)',
      'on': 'ON (it)',
      'off': 'OFF (it)',
      'confirmationInfoLine': 'Following changes will be submitted: (it)',
      'sortedBy': 'Sorted by (it)',
      'justificationInfoLine': 'Si prega di aggiungere una giustificazione per la modifica dei seguenti campi:',
      'justificationInfoLineShort': 'Please add a justification for changing: (it)',
      'viewSecureInfo': 'View Secure Info (it)',
      'hideSecureInfo': 'Hide Secure Info (it)',
      'sortTicketIdLabel': 'Ticket Id (it)',
      'loading': 'Loading...(it)',
    },
    'commonNotifications': {
      'timezoneChangeDetected': 'We\'ve detected you\'ve updated your time zone {{- timezone}}. Would you like to update your Relay time zone? (it)',
      'timezoneChangeApproved': 'Your Relay time zone was automtically updated to {{- timezone}} (it)',
      'updateProfile': 'Update Profile (it)',
    },
    'commonTooltips': {
      'tooltipAudit': 'Open Audit (it)',
      'exportConfig': 'Export Config (it)',
      'settings': 'Settings (it)',
    },
    'profilePage': {
      'firstName': 'Nome',
      'lastName': 'Cognome',
      'timeZone': 'Fuso Orario',
      'email': 'E-mail',
      'role': 'Role',
      'capability': 'Capability (it)',
      'partner': 'Partner',
      'locale': 'Language',
      'autoSubscribe': 'Auto Subscribe to my tickets (it)',
      'subscribeToNewReleases': 'Subscribe to Relay release notes (it)',
      'dashboard': 'Pannello di controllo',
      'switcherText1': 'Crea e segui i Tickets',
      'switcherText2': "Monitorare l'integrazione",
      'switcherTooltip1': 'Invia e gestisci i Ticket di gestione del servizio',
      'switcherTooltip2': 'Accedi alle statistiche, analizza gli errori e traccia globalmente i vincoli di salute',
      'avatarChange': 'Modifica',
      'useTimeFormat24': 'Use 24-hour time',
      'time24Hour': '24-hour time (it)',
      'timezoneAutodetect': 'Automatically detect time zone (it)',
      'myAccount': 'My Account (it)',
      'myPreferences': 'My Preferences (it)',
      'subscribeToNewTickets': 'Subscribe to new tickets (it)',
      'mySubscriptions': 'My Subscriptions (it)',
      'defaultImage': 'Default Image (it)',
      'openFile': 'Open File (it)',
    },
    'footer': {
      'releaseVersion': 'Release version (it)',
      'hash': 'Hash (it)',
      'deployedAt': 'Deployed at (it)',
    },
    'header': {
      'lastUpdate': 'Ultimo aggiornamento',
    },
    'mainHeader': {
      'partners': 'Partner',
      'users': 'Utenti',
      'audit': 'Revisione',
      'auditAll': 'Azioni di tutti i partner',
      'auditUsers': "Azioni dell'utente",
      'auditIntegration': 'Azioni di integrazione',
      'auditAdmin': 'Azioni dell\'amministratore',
      'sentEmails': 'E-mail spedite',
      'configuration': 'Configurazione',
      'configTicketProviders': 'Fornitori di Ticket',
      'configStatusCollections': 'Stato delle collezioni',
      'configMimeTypeCollections': 'Mime Type Collections (it)',
      'configSharedMaps': 'Mappe dei campi condivisi',
      'configMimeTypes': 'MIME Types (it)',
      'configTicketingSystems': 'Ticketing Systems (it)',
      'configQueries': 'Queries (it)',
      'configProviderTicketBoards': 'Ticket Boards (it)',
      'configSectionPartner': 'Partner (it)',
      'configSectionEngine': 'Engine (it)',
      'configSectionOtherSettings': 'Other Settings (it)',
      'configSectionInternal': 'Internal (it)',
      'configSectionAuthentication': 'Authentication (it)',
      'featureFlags': 'Feature Flags (it)',
      'requests': 'Richieste',
      'requestsPartner': 'Richieste del partner',
      'requestsInternal': 'Comunicazioni interne',
      'requestsProxy': 'Comunicazioni del delegato',
      'reports': 'Rapporti',
      'reportsUsers': 'Utenti',
      'reportsUserFilters': 'Filtri dell\'utente',
      'reportsSubscriptions': 'Sottoscrizioni',
      'reportsFeedback': 'Feedback (it)',
      'partnersNewTicket': 'Nuovo Ticket',
      'tickets': 'Ticket',
      'ticketsSectionPartner': 'Partner (it)',
      'ticketsSectionProvider': 'Provider (it)',
      'ticketsSectionProviders': 'Providers (it)',
      'about': 'Di',
      'aboutReleaseNotes': 'Note del rilascio',
      'aboutApiDocumentation': 'Documentazione delle API',
      'userProfile': 'My Profile (it)',
      'userSatClients': 'SAT Management (it)',
      'userSubscriptions': 'My Subscriptions (it)',
      'userSignOut': 'Disconnessione',
      'userSignOutTitle': 'SIGN OUT (it)',
      'userSignOutConfirm': 'Are you sure you want to sign out? (it)',
      'filteredBy': 'Filtered by: (it)',
      'searchPlaceholder': 'Search text in tickets... (it)',
      'webhookEvents': 'Webhook Events (it)',
      'asyncJobs': 'Async Jobs (it)',
      'maintenanceTasks': 'Maintenance Tasks (it)',
      'databasePerformance': 'Database Performance (it)',
      'satClients': 'Sat Clients (it)',
      'providerCredentials': 'Provider Credentials (it)',
      'globalSearch': {
        'placeholder': 'Search text in tickets... (it)',
        'noResults': 'no results (it)',
        'exactMatch': 'EXACT MATCH (it)',
        'suggested': 'SUGGESTED (it)',
        'viewAllResults': 'View all results (it)',
      },
    },
    'apiDocPage': {
      'pageTitle': 'API Documentation (it)',
      'title': 'OpenApi Specification (it)',
      'download': 'Download OpenApi Spec (it)',
      'rebuildCache': 'Refresh API Doc Cache (it)',
    },
    'dashboardPage': {
      'pageTitle': 'Dashboard (it)',
      'greeting': 'Ciao',
      'signedAs': 'Sei connesso come',
      'summaryTab': 'Summary (it)',
      'last24Hours': 'Ultime 24 ore',
      'last48Hours': 'Ultime 48 ore',
      'last7Days': 'Ultimi 7 giorni',
      'last30Days': 'Ultimi 30 giorni',
      'bonded': 'vincolato',
      'unbonded': 'Svincolato',
      'created': 'creato',
      'closed': 'chiuso',
      'open': 'aperto',
      'activeTickets': 'Ticket attivi',
      'activeUsers': 'active users',
      'withSubscriptions': 'with subscriptions',
      'moreLink': 'Di Più',
      'bondedVsUnbondedTooltip': 'A widget shows count of all tickets\nby all time of bonded and unbonded ones (it)',
      'bondedVsUnbonded': 'Vincolato vs. svincolato',
      'createdVsClosedTooltip': 'A widget shows count of all tickets\nwhich were created and closed by all time (it)',
      'createdVsClosed': 'Creato vs. chiuso',
      'httpCodeRequestTooltip': 'A widget shows count of all requests\ngrouped by response code (it)',
      'httpCodeRequest': 'Richieste codice http',
      'recentTicketsTooltip': 'Latest created tickets (it)',
      'recentTicketsHeader': 'Ticket recenti',
      'lastTicketSuccess': 'Successo dell\'ultimo Ticket',
      'lastTicketFail': 'Fallimento dell\'ultimo Ticket',
      'lastCommentSuccess': 'Successo dell\'ultimo commento',
      'lastCommentFail': 'Fallimento dell\'ultimo commento',
      'lastAttachmentSuccess': 'Successo dell\'ultimo allegato',
      'lastAttachmentFail': 'Fallimento dell\'ultimo allegato',
      'action': 'azione',
      'time': 'Tempo a',
      'createAction': 'Crea',
      'updateAction': 'Aggiorna',
      'collectionAction': 'collezione',
      'recentApiRequestHeader': 'recenti richieste api',
      'latestRequestTooltipText': "Latest partner's requests to Relay API\nfor selected Ticketing system (it)",
      'latestRequestStatusTooltipText': "Table shows date of last success requests for ticket's action:\ncreate, update (and update status), collection (fetch all tickets) (it)",
      'latestFailRequestTooltipText': "Table shows date of last fail requests for ticket's action:\ncreate, update (and update status), collection (fetch all tickets) (it)",
      'latestCommentSuccessTooltipText': 'Date of last success request to create comment (it)',
      'latestCommentFailTooltipText': 'Date of last fail request to create comment (it)',
      'latestAttachmentSuccessTooltipText': 'Date of last success request to create attachment (it)',
      'latestAttachmentFailTooltipText': 'Date of last fail request to create attachment (it)',
      'code': 'Codice',
      'entity': 'Entità',
      'request': 'Richiesta',
      'msgResponse': 'Messaggio di risposta',
      'url': 'url',
      'executed': 'Eseguito a',
      'activeSubscTooltip': 'List of latest emails which were sent to subscribers (it)',
      'activeSubscHeader': 'Abbonamenti attivi iniziati',
      'user': 'utente',
      'status': 'stato',
      'ticket': 'id',
      'createdClosedChart': 'ticket creati/chiusi',
      'responseCodesChart': 'codici di risposta HTTP',
      'adminRole': 'Amministratore',
      'role': 'Ruolo',
      'adminRoRole': 'Sola lettura dell\'amministratore',
      'impersonate': 'Impersonare',
    },
    'ticketsPage': {
      'breadcrumbTicketingSystem': 'Sistema di Ticketing',
      'removeTicketsTitle': 'Elimina Ticket',
      'removeTicketTitle': 'Elimina Ticket',
      'removeTicketsMessage_one': 'Please confirm that you want to remove {{count}} ticket: {{numbers}} (it)',
      'removeTicketsMessage_other': 'Please confirm that you want to remove {{count}} tickets: {{numbers}} (it)',
      'statusesFilterPlaceholder': 'All Statuses (it)',
      'searchPlaceholder': 'Cerca {{tsName}} ticket...',
      'searchPlaceholderNew': 'search tickets (it)',
      'bulkRemoveLink': 'Cancellazione massiva',
      'removeTicketsLink': 'Elimina i Ticket selezionati',
      'reloadTicketsLink': 'Ricarica i Ticket',
      'status': 'Stato',
      'ticket': 'Ticket',
      'ticketsFound': '{{ticketsCount}} tickets found by: (it)',
      'ticketsCount_one': '{{count}} ticket (it)',
      'ticketsCount_other': '{{count}} tickets (it)',
      'sortedByPlaceholder': 'Choose Sorting Field (it)',
      'resetSortingTooltip': 'Reset to Default (it)',
      'sortDirectionTooltip': 'Reverse Sort Direction (it)',
      'sortRelayTicketIdLabel': 'Relay Ticket Id (it)',
      'clearFiltersLink': 'Cancella tutti i filtri',
      'tableHeaderId': 'Ticket ID',
      'tableHeaderTitle': 'Titolo',
      'tooltipMultiUserFilter': 'Filtro multiutente',
      'tooltipAdminOnlyFilter': 'Admin-only filter (it)',
      'tooltipPrivateFilter': 'Private filter (it)',
      'filters': 'Filtri',
      'removeFilterTitle': 'Elimina filtro',
      'removeFilterMessage': 'Sei sicuro che vuoi eliminare il filtro  \'{{ filterName }}\'?',
      'subscribeToNewTickets': 'Subscribe to new tickets (it)',
      'unSubscribeToNewTickets': 'Unsubscribe from new tickets (it)',
      'subscribeToTicketsView': 'Subscribe to receive notifications about new tickets (it)',
      'unSubscribeToTicketsView': 'Unsubscribe from tickets view (it)',
      'subscribeToTicketsViewTitle': 'Subscribe to Tickets View (it)',
      'subscribeToTicketsViewName': 'View Name (it)',
      'subscribeToTicketsViewFilters': 'Filters (it)',
      'subscribeToTicketsViewStatuses': 'Statuses (it)',
      'subscribeToTicketsViewSearch': 'Search (it)',
      'subscribeToTicketsViewAllTickets': 'All Tickets (it)',
      'subscribeToTicketsViewGroupName': 'Tickets View (it)',
      'manageSubscriptions': 'Manage Subscriptions (it)',
      'tooltipChildTickets_one': 'This ticket contains {{childTicketsIds}} child (it)',
      'tooltipChildTickets_other': 'This ticket contains {{childTicketsIds}} children (it)',
      'tooltipChildTicketsMore': ' and {{count}} more (it)',
      'attachmentsCount_one': '{{count}} attachment (it)',
      'attachmentsCount_other': '{{count}} attachments (it)',
      'commentsCount_one': '{{count}} comment (it)',
      'commentsCount_other': '{{count}} comments (it)',
      'emptyFiltersText': 'No active filters available (it)',
      'createFilterTooltip': 'Create Filter (it)',
      'editFilterTooltip': 'Edit Filter (it)',
      'removeFilterTooltip': 'Remove Filter (it)',
      'filterPanelTitle': 'Tickets View (it)',
      'filterPanelTitleTooltip': 'Click to open Tickets View filter sidebar (it)',
      'filterPanelFiltersTooltip': 'Active Custom Filters (it)',
      'filterPanelClearFiltersTooltip': 'Clear Custom Filters (it)',
      'filterPanelClearStatusesTooltip': 'Clear Status Filters (it)',
      'filterPanelSearchTooltip': 'Click to Search (it)',
      'filterPanelClearSortingTooltip': 'Clear Sorting (it)',
      'filtersStatusSectionTitle': 'Statuses (it)',
      'filterForm': {
        'title': 'Filter Settings (it)',
        'generalInformation': 'General Information (it)',
        'conditions': 'Conditions (it)',
        'saveFilter': 'Save Filter (it)',
        'deleteFilter': 'Delete Filter (it)',
        'fieldLabelName': 'Name (it)',
        'fieldLabelVisibility': 'Visibility (it)',
        'visibilityPrivate': 'Private (it)',
        'visibilityAdmins': 'Admins (it)',
        'visibilityAllUsers': 'All Users (it)',
        'providerTicketBoards': 'Ticket Boards (it)',
        'providerTicketBoardsPlaceholder': 'Ticket Boards Visibility (it)',
        'advancedMode': 'Advanced mode (it)',
        'addNewCondition': 'Add New Condition (it)',
        'advancedTooltip':
          'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
          'Keywords: AND, OR\n\n' +
          'Example:\n' +
          'title LIKE "test" OR severity IN 5,4,3 (it)',
        'resultExpression': 'Result Expression (it)',
        'resultExpressionText': 'Mostra quando {{- query}}',
        'table': {
          'field': 'field (it)',
          'operator': 'operator (it)',
          'value': 'value (it)',
        },
        'allFieldsLabel': 'Ticket Fields (it)',
        'dynamicFieldsLabel': 'Dynamic Options (it)',
        'selectFieldPlaceholder': 'select field (it)',
        'selectOperatorPlaceholder': 'select operator (it)',
        'selectValuePlaceholder': 'select value (it)',
        'optionLabels': {
          'is_me': 'Is Me (it)',
          'my_company': 'My Company (it)',
        },
        'removeConditionTooltip': 'Remove Condition (it)',
      },
    },
    'ticketFilterForm': {
      'updateFilter': 'Aggiorna filtro',
      'createNewFilter': 'Crea nuovo filtro',
      'validateMsgNameRequired': 'E\' richiesto il nome',
      'validateMsgNameExists': 'Il nome già esiste',
      'validateMsgQueryReuired': 'E\' richiesta una query',
      'validateMsgConditionsRequired': 'Sono richieste condizioni',
      'validateMsgConditionsEmpty': 'Il valore della condizione con può essere vuoto',
      'conditionsTip':
        'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
        'Keywords: AND, OR\n\n' +
        'Example:\n' +
        'title LIKE "test" OR severity IN 5,4,3',
      'name': 'Nome',
      'namePlaceholder': 'Nome filtro...',
      'conditions': 'Condizioni',
      'advanced': 'Avanzati',
      'multiUser': 'Abilitato multiutente',
      'showWhenCondition': 'Mostra quando {{- condition}}',
      'addQuery': 'Aggiungi una query',
      'queryPlaceholder': 'Scrivi la query',
      'saveFilter': 'Salva il filtro',
      'allFieldsLabel': 'Ticket Fields (it)',
      'dynamicFieldsLabel': 'Dynamic Options (it)',
      'isMe': 'Is Me (it)',
      'myCompany': 'My Company (it)',
    },
    'ticketPage': {
      'tableNoData': 'nessun dato',
      'cloneTicketLink': 'Clona Ticket',
      'createTicketLink': 'Create ticket (it)',
      'deleteTicketLink': 'Elimina Ticket',
      'editModeLink': 'Modifica i dettagli',
      'refetchTicketLink': 'Ricarica Ticket',
      'requestTicketLink': 'Mostra le richieste dei Ticket',
      'addChildTicketsLink': 'Add tickets (it)',
      'moveTicketLink': 'Move ticket (it)',
      'removeTicketTitle': 'Remove Ticket (it)',
      'removeTicketMessage': 'Please confirm that you want to remove ticket: {{number}} (it)',
      'webhookTicketLink': 'Show webhook events (it)',
      'unsubscribeLink': 'Annulla sottoscrizione',
      'subscribeLink': 'Abbonati',
      'subscribeLinkHint': 'Non sei abilitato a sottoscrivere, <1>per favore aggiorna la tua email!</1>',
      'commentsAll': 'Tutti',
      'commentsOnly': 'solo',
      'comments': 'Commenti',
      'commentNew': 'Nuovo commento',
      'commentsNo': 'Non ci sono commenti',
      'commentsValidateBody': 'E\' richiesto un commento',
      'commentAbsoluteDate': '{{author}} ha commentato in data {{date}}',
      'commentedAt': 'ha commentato in data {{date}}',
      'attachments': 'Allegati',
      'attachmentAdd': 'Aggiungi allegato',
      'attachmentTooBig': 'Attachment file is too big (it)',
      'attachmentInvalidType': 'Attachment file is invalid: {{extension}} ({{contentType}}) (it)',
      'attachmentsNo': 'Non ci sono allegati',
      'attachmentsHeaderId': 'ID',
      'attachmentsHeaderFilename': 'Nome del file',
      'attachmentsHeaderOwner': 'Proprietario',
      'attachmentsHeaderCreated': 'Creato',
      'attachmentsHeaderSize': 'Dimensione',
      'sidebarDetails': 'Dettagli',
      'sidebarSectionTicketingSystem': 'Sistema di Ticketing',
      'sidebarSectionTicketId': 'Ticket ID (it)',
      'sidebarSectionRelayId': 'Relay Ticket ID',
      'sidebarSectionType': 'Type (it)',
      'sidebarSectionChildren': {
        'title': 'Children (it)',
        'columns': {
          'id': 'Ticket ID (it)',
          'title': 'Title (it)',
        },
      },
      'sidebarSectionParent': 'Parent (it)',
      'hideReadOnlyFields': 'Hide Read-Only Fields (it)',
      'filteredBy': 'Filtered By (it)',
      'attachmentsFilter': {
        'partnersFilterPlaceholder': 'All Partners (it)',
        'extensionsFilterPlaceholder': 'All Types (it)',
        'searchPlaceholder': 'search attachments (it)',
        'filterPanelSearchTooltip': 'Click to Search (it)',
        'filterPanelClearSortingTooltip': 'Clear Sorting (it)',
        'sortFieldLabels': {
          'external_created_at': 'CREATED DATE (it)',
          'type': 'TYPE (it)',
          'size': 'SIZE (it)',
          'filename': 'FILE NAME (it)',
        },
      },
      'commentsFilter': {
        'partnersFilterPlaceholder': 'All Partners (it)',
        'authorsFilterPlaceholder': 'All Authors (it)',
        'searchPlaceholder': 'search comments (it)',
        'filterPanelSearchTooltip': 'Click to Search (it)',
        'filterPanelClearSortingTooltip': 'Clear Sorting (it)',
        'sortFieldLabel': 'CREATED DATE (it)',
      },
      'childrenSection': {
        'title': 'Children (it)',
      },
      'addTicketsForm': {
        'title': 'Add Tickets (it)',
        'ticketList': 'Ticket List (it)',
        'placeholder': 'Enter ticket ID or title (it)',
      },
      'moveTicketForm': {
        'title': 'Move Ticket (it)',
        'parentTicket': 'Parent (it)',
        'placeholder': 'Enter ticket ID or title (it)',
      },
    },
    'dropzoneFileInput': {
      'placeholder': 'Apri o non considerare il file',
      'maxSizeInfo': 'Max upload size: {{maxSizeText}} (it)',
    },
    'fileProgressbar': {
      'progressText': '{{currentBytesText}} of {{totalBytesText}} (it)',
    },
    'exportFileProgressBar': {
      'progressText': '{{currentPercent}}% of CSV file generated (it)',
    },
    'sidebar': {
      'title': 'Details (it)',
      'statusSection': 'STATO',
      'userSection': 'Creato dall\'utente',
      'noData': 'nessun dato',
      'sidebarSectionsBySchema': {
        'sectionStatusCollectionLinkTooltip': 'Open Status Collection (it)',
        'sectionSharedMapLinkTooltip': 'Open Shared Fields Map (it)',
        'sectionMimeTypeCollectionLinkTooltip': 'Open Mime Type Collection (it)',
        'sectionTicketProviderLinkTooltip': 'Open Ticket Provider (it)',
        'sectionProviderCredentialLinkTooltip': 'Open Provider Credential (it)',
      },
    },
    'ticketEditPage': {
      'pageHeader': 'Modifica {{ticketName}} in {{tsName}}',
      'fields': 'Fields (it)',
    },
    'ticketClonePage': {
      'pageHeader': 'Clona Ticket in {{tsName}}',
    },
    'ticketCreatePage': {
      'pageHeader': 'Crea Ticket in {{tsName}}',
    },
    'ticketRequestsPage': {
      'pageHeader': 'Requests for {{ticketName}} in {{tsName}} (it)',
    },
    'ticketForm': {
      'buttonCloneTicket': 'Clona Ticket',
      'buttonCreateTicket': 'Crea Ticket',
      'inheritedFromParent': 'Inherited from parent (it)',
    },
    'tableFormFieldsBuilder': {
      'creatableArrayField': {
        'text': 'or add via CSV/XLS file (it)',
        'tooltip': 'Open CSV/XLS file (it)',
        'optionsEmpty': 'Empty (it)',
        'optionsAdd': 'Add (it)',
        'itemsMax_one': 'maximum {{count}} item (it)',
        'itemsMax_other': 'maximum {{count}} items (it)',
        'itemsLeft_one': '{{count}} item left (it)',
        'itemsLeft_other': '{{count}} items left (it)',
        'itemsOver_one': '{{count}} item over (it)',
        'itemsOver_other': '{{count}} items over (it)',
        'placeholderAddItems': 'Aggiungi elementi...',
      },
      'editableArrayField': {
        'tooltipAdd': 'Add New Item (it)',
        'tooltipRemove': 'Remove Item (it)',
        'addButtonLabel': 'Add Item (it)',
      },
    },
    'appRequestsPage': {
      'header': 'Requests (it)',
      'tableHeaderRequest': 'Request (it)',
      'tableHeaderPartner': 'Partner (it)',
      'tableHeaderOrigin': 'Origin (it)',
      'tableHeaderMethod': 'Method (it)',
      'tableHeaderExecutedAt': 'Executed At (it)',
      'tableHeaderCode': 'Code (it)',
      'tableHeaderResponseTime': 'Response Time (it)',
      'sidebarDetails': 'REQUEST DETAILS (it)',
      'sidebarSectionRequestId': 'Request ID (it)',
      'sidebarSectionCorrelationId': 'Correlation ID (it)',
      'sidebarSectionTicketIds': 'Ticket IDs (it)',
      'sidebarSectionTicketProvider': 'Ticket Provider (it)',
      'sidebarSectionTicketProviderId': 'Id (it)',
      'sidebarSectionTicketProviderName': 'Name (it)',
      'sidebarSectionTs': 'Ticketing System (it)',
      'sidebarSectionTsId': 'ID (it)',
      'sidebarSectionTsName': 'Name (it)',
      'sidebarSectionUrl': 'URL (it)',
      'sidebarSectionRespondedAt': 'Responded at (it)',
      'sidebarSectionRespPayload': 'Response Payload (it)',
      'sidebarSectionAuthToken': 'Auth Token (it)',
      'sidebarSectionReqPayload': 'Request Payload (it)',
      'sidebarSectionReqPayloadSize': 'Request Payload Size (it)',
      'sidebarSectionServerName': 'Server Name (it)',
      'sidebarSectionReleaseVersion': 'Release Version (it)',
      'sidebarSectionSourceIp': 'Source IP (it)',
      'sidebarSectionClientId': 'Client ID (it)',
      'sidebarSectionExternalRequestId': 'External Request ID (it)',
      'sidebarSectionWebhookEventId': 'Webhook Event ID (it)',
      'sidebarSectionWebhookExternalEventId': 'Webhook External Event ID (it)',
      'filtersSidebarTitle': 'Filters (it)',
      'clearFiltersLink': 'Clear All Filters (it)',
      'requestsFound_one': '{{count}} request found (it)',
      'requestsFound_other': '{{count}} requests found (it)',
      'traceTooltip': 'Find telemetry trace (it)',
      'copyTooltip': 'Copy Request Details (it)',
    },
    'searchBy': {
      'title': 'Ricerca per',
      'placeholder': 'ricerca',
    },
    'subscriptionsPage': {
      'header': 'Subscriptions (it)',
      'tableHeaderId': 'Ticket ID',
      'tableHeaderStatus': 'Stato',
      'tableHeaderTitle': 'Titolo',
      'tableHeaderUpdated': 'Ticket Updated (it)',
      'inactiveTooltip': 'Il sistema di Ticketing per questo Ticket non è attivo',
      'unsubscribeTooltip': 'Annulla sottoscrizione ',
      'subscriptionTypeTickets': 'Tickets (it)',
      'subscriptionTypeViews': 'Views (it)',
      'subscriptionName': 'Name (it)',
      'subscriptionCreatedAt': 'Created At (it)',
      'subscriptionFilteredBy': 'Filtered by (it)',
      'subscriptionsFound': '{{subscriptionsCount}} subscriptions found by (it):',
      'filterTsLabel': 'All Ticketing Systems (it)',
      'subscribeToAllTickets': 'All Tickets (it)',
      'subscribeToStatus': 'Statuses (it)',
      'subscribeToFilter': 'Filters (it)',
      'subscribeToSearch': 'Search (it)',
      'clearFiltersLink': 'Clear All Filters (it)',
      'filterPanelClearSortingTooltip': 'Clear Sorting (it)',
      'subscriptionGoToViews': 'Open Tickets View (it)',
      'FiltersText': 'Filters (it)',
      'SearchText': 'Search (it)',
      'providerTicketBoardText': 'Board (it)',
      'subscriptionsCount_one': '{{count}} subscription (it)',
      'subscriptionsCount_other': '{{count}} subscriptions (it)',
    },
    'releaseNotesPage': {
      'header': 'Note di rilascio',
      'headerAdd': 'Aggiungi nuova release',
      'headerEdit': 'Modifica release {{releaseName}}',
      'addRelease': 'Aggiungi nuova release',
      'subscribeRelease': 'Subscribe to Release Notes (it)',
      'unsubscribeRelease': 'Unsubscribe from Release Notes (it)',
      'editRelease': 'Edit Release (it)',
      'sidebarHeader': 'Archivio dei rilasci',
      'publishedTooltip': 'Rilascio pubblicato',
      'unpublishedTooltip': 'Unpublished Release (it)',
      'publishedBadge': 'published (it)',
      'unpublishedBadge': 'unpublished (it)',
      'releaseEmpty': 'La lista delle note di rilascio è vuota',
      'removeReleaseTitle': 'Elimina nota della release',
      'removeReleaseMessage': 'Sei sicuro di voler eliminare la nota di rilascio?',
      'editConfirmTitle': 'Save Changes? (it)',
      'editConfirmMessage': 'Please confirm your changes. (it)',
      'formUpdateRelease': 'Aggiorna release',
      'formRemoveRelease': 'Elimina release',
      'formVersion': 'VERSIONE',
      'formVersionPlaceholder': 'type here (it)',
      'formDate': 'DATA',
      'formDatePlaceholder': 'please select date & time (it)',
      'formPublished': 'PUBBLICATO',
      'formDescription': 'DESCRIZIONE',
      'formDescriptionPlaceholder': 'add description (it)',
      'formDescriptionTooltip':
        'Please use next format for release notes:\n\n' +
        '## Title Text\n' +
        '### Section 1\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '### Section 2\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '...\n' +
        '### Section N\n' +
        '- Item 1\n' +
        '- Item 2\n' +
        '- ...\n' +
        '- Item N\n' +
        '## Footer Text (it)',
    },
    'datetimeInput': {
      'placeholderDate': 'Seleziona la data',
      'placeholderDateTime': 'Seleziona la data e l\'ora',
      'timeLabel': 'TIME (it)',
      'am': 'am (it)',
      'pm': 'pm (it)',
      'hours': 'HOURS (it)',
      'minutes': 'MINUTES (it)',
      'seconds': 'SECONDS (it)',
    },
    'sentEmailsPage': {
      'title': 'Invia email',
      'filterPanelTitle': 'Filters (it)',
      'filterPanelTitleTooltip': 'Click to open filters sidebar (it)',
      'clearFilterTooltip': 'Clear {{filterName}} filter (it)',
      'clearAllFiltersTooltip': 'Clear all filters (it)',
      'filterPanelFiltersTooltip': 'Active filters (it)',
      'emailsCount': '{{count}} emails (it)',
      'filters': {
        'recipient': 'Recipient (it)',
        'ticketNumber': 'Ticket Number (it)',
        'subject': 'Subject (it)',
        'partner': 'Partner (it)',
        'partners': 'Partners (it)',
        'ticketProvider': 'Ticket Provider (it)',
        'actionType': 'Action Type (it)',
        'code': 'Code (it)',
        'codes': 'Codes (it)',
        'state': 'State (it)',
        'status': 'Status (it)',
      },
      'table': {
        'headerPartner': 'Partner (it)',
        'headerSmtpCode': 'Codice SMTP',
        'headerSubject': 'Soggetto:',
        'headerRecipient': 'Destinatario',
        'headerSentAt': 'Inviato a',
        'actionResendToMe': 'Rimandalo a me',
        'actionResendToMeError': 'Rimandalo a me (Fallire)',
        'headerType': 'Action Type (it)',
      },
      'rightSideBar': {
        'title': 'DETTAGLI DELLA MAIL',
        'sectionSubject': 'Soggetto',
        'sectionRecipient': 'Destinatario',
        'sectionSmtpRespMsg': 'Messaggio di risposta SMTP',
        'sectionTicketNumber': 'Numero Ticket',
        'sectionTicketingSystem': 'Sistema di Ticketing',
        'sectionState': 'State (it)',
      },
    },
    'columnsPage': {
      'pageHeader': 'Manage Columns for (it)',
      'addColumn': 'Add Column (it)',
      'addNewColumn': 'Add New Column (it)',
      'formFieldName': 'Partner Name (it)',
      'formFieldColId': 'External Name (it)',
      'removeColumn': 'Remove Column (it)',
      'removeColumnMessage': 'Are you sure you want to remove \'{{ columnName }}\' column? (it)',
      'restoreSharedColumn': 'Restore Shared Column (it)',
      'restoreSharedColumnMessage': 'Are you sure you want to restore \'{{ columnName }}\' shared column? (it)',
      'restoreTooltip': 'Restore Shared (it)',
      'removeTooltip': 'Remove (it)',
      'sharedTooltip': 'Shared (it)',
      'customizedTooltip': 'Customized (it)',
      'compareTooltip': 'Compare field map (it)',
      'loadingMatches': 'Loading... (it)',
      'noMatches': 'No matches (it)',
      'tableHeaderPartnerColumnName': 'partner column name (it)',
      'tableHeaderExternalColumnName': 'external column name (it)',
      'tableHeaderVisible': 'visible (it)',
      'tableHeaderFormVisible': 'visible in form (it)',
      'tableHeaderViewVisible': 'visible in view (it)',
      'tableHeaderFormCreatable': 'creatable (it)',
      'tableHeaderPreview': 'preview (it)',
      'tableHeaderCloned': 'cloned (it)',
      'tableHeaderCloneable': 'cloneable (it)',
      'tableHeaderRequired': 'required (it)',
      'tableHeaderFilterable': 'filterable (it)',
      'tableHeaderFieldType': 'field type (it)',
      'tableHeaderCommentRequired': 'Commento obbligatorioe',
      'columnNamePlaceholder': 'Please enter column name (it)',
      'columnExternalColumnIdPlaceholder': 'Please enter external name (it)',
      'rightSideBar': {
        'formConfig': 'Form Config (it)',
        'viewConfig': 'View Config (it)',
        'formConfigTooltip': 'Configure columns on Ticket Create/Edit/Clone pages (it)',
        'viewConfigTooltip': 'Configure columns on Ticket/Tickets View pages (it)',
        'localizedFieldsOnly': 'Localizations fields only (it)',
        'partnerColumnName': 'Partner Name (it)',
        'externalColumnName': 'External Name (it)',
        'defineAllowed': 'Define Allowed (it)',
        'defineValueMapping': 'Define Value Mapping (it)',
        'defineExternalToPartnerMapping': 'Enable external value mapping (it)',
        'definePartnerToExternalMapping': 'Enable partner value mapping (it)',
        'defineTableTypeConfig': 'Configurazione della tabella',
        'tableTypeConfigIsEmpty': 'La tabella è vuota',
        'addTableTypeConfigItem': 'Aggiungi colonna',
        'editTableTypeConfigItem': 'Modifica colonna',
        'partnerValue': 'partner value (it)',
        'externalValue': 'external value (it)',
        'allowed': 'Allowed (it)',
        'allowedIsEmpty': 'Allowed list is empty (it)',
        'name': 'Name (it)',
        'namePlaceholder': 'Please enter name (it)',
        'value': 'Value (it)',
        'valuePlaceholder': 'Please enter value (it)',
        'default': 'default (it)',
        'tooltip': 'tooltip (it)',
        'placeholder': 'placeholder (it)',
        'visible': 'visible (it)',
        'writeable': 'writeable (it)',
        'creatable': 'creatable (it)',
        'editable': 'editable (it)',
        'setOnce': 'set once (it)',
        'displayInSidebar': 'display in sidebar (it)',
        'showInPreview': 'show in preview (it)',
        'displayInPreview': 'display in preview (it)',
        'cloned': 'cloned (it)',
        'cloneable': 'cloneable (it)',
        'filterable': 'filterable (it)',
        'sortable': 'sortable (it)',
        'hideValueInEmail': 'Hide value in Email (it)',
        'notifyViaEmail': 'Notify via Email (it)',
        'field_type': 'Field Type (it)',
        'main_ui_attr': 'Main UI Attribute (it)',
        'main_external_attr': 'Main External Attribute (it)',
        'nested_field_name': 'Nested Field Name (it)',
        'required': 'required (it)',
        'commentRequired': 'commento obbligatorioe',
        'tooltipRequired': 'Field can be required if it has default value or it is visible and writeable (it)',
        'tooltipShowInPreview': 'Show this field in the preview section on the Tickets List page (it)',
        'tooltipDisplayInSidebar': 'Show this field in the sidebar section on the Ticket View page (it)',
        'tooltipDisplayInSidebarFormConfig': 'Show this field in the sidebar section on the Ticket Create/Edit/Clone pages (it)',
        'manageAllowed': 'MANAGE FIELD MAPPING (it)',
        'modalHeader': 'Discard Changes (it)',
        'modalText': 'Are you sure you want to discard changes? (it)',
        'modalHeaderRemove': 'Remove {{columnName}} (it)',
        'modalTextRemove': 'Are you sure you want to remove \'{{valueName}}\' {{columnName}}? (it)',
        'tooltipEdit': 'Edit (it)',
        'tooltipRemove': 'Remove (it)',
        'addAllowed': 'Add Allowed Value (it)',
        'editAllowed': 'Edit Allowed Value (it)',
        'changeOrder': 'Change Order (it)',
        'addExternalValueMapping': 'Add New External Value Map (it)',
        'editExternalValueMapping': 'Edit External Value Map (it)',
        'externalValueMappingIsEmpty': 'External value mapping is empty (it)',
        'removeExternalMappingValue': 'Remove External Value Map (it)',
        'removeExternalMappingValueText': 'Are you sure you want to remove \'{{ externalValue }}\' external value map? (it)',
        'addPartnerValueMapping': 'Add New Partner Value Map (it)',
        'editPartnerValueMapping': 'Edit Partner Value Map (it)',
        'partnerValueMappingIsEmpty': 'Partner value mapping is empty (it)',
        'removePartnerMappingValue': 'Remove Partner Value Map (it)',
        'removePartnerMappingValueText': 'Are you sure you want to remove \'{{ partnerValue }}\' partner value map? (it)',
        'externalValueForm': {
          'value': 'value (it)',
          'valuePlaceholder': 'input value (it)',
        },
        'emptyPartnerValue': 'empty (it)',
        'partnerValueForm': {
          'value': 'value (it)',
          'valuePlaceholder': 'input value (it)',
          'default': 'default (it)',
        },
        'arrayCsvLimit': 'Limit of max number of items (it)',
      },
      'settingsModal': {
        'title': 'Column Settings (it)',
      },
    },
    'select': {
      'noOptions': 'no data (it)',
      'placeholder': 'Select... (it)',
      'loadingMessage': 'loading... (it)',
    },
    'partnersPage': {
      'pageHeader': 'Partners (it)',
      'addPartner': 'Add Partner (it)',
      'addNewPartner': 'Add New Partner (it)',
      'formFieldName': 'Name (it)',
      'partnerNamePlaceholder': 'Please enter partner name (it)',
      'formFieldXerxesPartnerName': 'Xerxes Name (it)',
      'formFieldXerxesPartnerNamePlaceholder': 'Please enter Xerxes partner name (it)',
      'fieldSsoZone': 'SSO Zone (it)',
      'fieldSsoEnv': 'SSO Environment (it)',
      'ssoZonePlaceholder': 'Please select SSO Zone (it)',
      'ssoEnvPlaceholder': 'Please select SSO Environment (it)',
      'fieldXerxesZone': 'Xerxes Zone (it)',
      'fieldXerxesEnv': 'Xerxes Environment (it)',
      'xerxesZonePlaceholder': 'Please select Xerxes Zone (it)',
      'xerxesEnvPlaceholder': 'Please select Xerxes Environment (it)',
      'formFieldSatPartnerName': 'SAT Name (it)',
      'formFieldSatPartnerNamePlaceholder': 'Please enter SAT partner name (it)',
      'fieldSatZone': 'SAT Zone (it)',
      'satZonePlaceholder': 'Please select SAT Zone (it)',
      'fieldSatEnv': 'SAT Environment (it)',
      'satEnvPlaceholder': 'Please select SAT Environment (it)',
      'removePartnerTitle': 'Remove Partner (it)',
      'removePartnerMessage': 'Are you sure you want to remove \'{{partnerName}}\' partner? (it)',
      'tableHeaderPartnerName': 'partner name (it)',
      'tableHeaderMainPartner': 'main partner (it)',
      'tableHeaderActive': 'active (it)',
      'tableHeaderVisibility': 'visibility (it)',
      'visibilityFull': 'full (it)',
      'visibilityRestricted': 'restricted (it)',
      'tooltipOauthApps': 'Manage Oauth apps (it)',
      'tooltipGenerateOpenApi': 'Generate OpenApi (it)',
      'tooltipTicketingSystems': 'Ticketing Systems (it)',
      'tooltipRemovePartner': 'Remove Partner (it)',
      'rightSideBar': {
        'sectionPartnerName': 'Partner Name (it)',
        'sectionXerxesPartnerName': 'Xerxes Partner Name (it)',
        'sectionActive': 'Active (it)',
        'sectionMainPartner': 'Main Partner (it)',
        'sectionUseMtls': 'Use MTLS authentication (it)',
        'sectionVisibility': 'Visibility (it)',
        'sectionLogo': 'Logo (it)',
        'sectionSystemBranding': {
          'title': 'System Branding (it)',
          'copyrightText': 'Copyright Text (it)',
          'logo': 'Logo (it)',
        },
        'sectionLandingPage': {
          'header': 'Landing Page Content (it)',
          'title': 'Title (it)',
          'titlePlaceholder': 'Please, enter title (it)',
          'text': 'Text (it)',
          'textPlaceholder': 'Please, enter text (it)',
        },
        'sectionManage': 'Manage (it)',
        'visibilityFull': 'Full (it)',
        'visibilityRestricted': 'Restricted (it)',
        'sectionTicketIdName': 'Ticket id field name (it)',
      },
      'settingsModal': {
        'title': 'Partner Settings (it)',
      },
    },
    'iconRecommendation': {
      'recommendations': 'Recommendations (it)',
      'size': 'size (it)',
      'formats': 'formats (it)',
      'uploadLogo': 'Upload Logo (it)',
    },
    'imagePicker': {
      'recommendationsTitle': 'Recommendations (it)',
      'size': 'size (it)',
      'formats': 'formats (it)',
      'uploadLogo': 'Upload Logo (it)',
      'updateLogo': 'Update Logo (it)',
    },
    'statusCollectionsPage': {
      'pageHeader': 'Status Collections (it)',
      'addEntity': 'Add Status Collection (it)',
      'importStatusCollection': 'Import Status Collection (it)',
      'addNewEntity': 'Add New Status Collection (it)',
      'formFieldName': 'Name (it)',
      'statusCollectionNamePlaceholder': 'Please enter Status Collection name (it)',
      'removeStatusCollectionTitle': 'Remove Status Collection (it)',
      'removeStatusCollectionMessage': 'Are you sure you want to remove \'{{statusCollectionName}}\' status collection? (it)',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticketing systems or ticket providers (it)',
      'hintCannotBeRemovedHasStatuses': 'Cannot be removed while it has partner statuses (it)',
      'manageStatuses': 'Manage Partner Statuses (it)',
      'tableHeaderName': 'Status Collection Name (it)',
      'rightSideBar': {
        'title': 'DETAILS (it)',
        'sectionUsedBy': 'Used By (it)',
        'sectionUsedByTicketingSystem': 'Ticketing Systems (it)',
        'sectionUsedByTicketProvider': 'Ticket Providers (it)',
      },
      'settingsModal': {
        'title': 'Status Collection Settings (it)',
      },
    },
    'statusCollectionPage': {
      'pageHeader': 'Partner Statuses for (it)',
      'addEntity': 'Add Partner Status (it)',
      'addNewEntity': 'Add new partner status (it)',
      'tableHeaderPartnerStatus': 'Partner Status (it)',
      'tableHeaderExternalStatuses': 'External Statuses (it)',
      'tableHeaderDefault': 'Default (it)',
      'removePartnerStatusTitle': 'Remove partner status (it)',
      'removePartnerStatusMessage': 'Are you sure you want to remove \'{{ partnerStatusName }}\' partner status? (it)',
      'tooltipRemove': 'Remove (it)',
      'partnerStatusName': 'Name (it)',
      'partnerStatusClosedState': 'Closed State (it)',
      'partnerStatusNamePlaceholder': 'Please enter partner status name (it)',
      'partnerStatusColor': 'Status Color (it)',
      'partnerStatusDefault': 'Default (it)',
      'extFormName': 'Name (it)',
      'extFormNamePlaceholder': 'Please enter name for external status (it)',
      'extFormNotes': 'Notes (it)',
      'extFormNotesPlaceholder': 'Please enter notes for external status (it)',
      'extFormStatusTrans': 'Status Transitions (it)',
      'extFormReadOnly': 'Read Only (it)',
      'manageExternalStatuses': 'Manage External Statuses (it)',
      'externalStatusesTab': 'External Statuses (it)',
      'rightSideBar': {
        'title': 'DETAILS (it)',
      },
      'settingsModal': {
        'title': 'Partner Status Settings (it)',
      },
    },
    'externalStatusesPage': {
      'pageHeader': 'External Statuses for (it)',
      'addEntity': 'Add External Status (it)',
      'addNewEntity': 'Add New External Status (it)',
      'breadcrumbExternalStatuses': 'External Statuses (it)',
      'tableHeaderName': 'Name (it)',
      'tableHeaderNote': 'Note (it)',
      'tableHeaderTransitions': 'Transitions (it)',
      'tableHeaderReadOnly': 'Read Only (it)',
      'removeExternalStatusTitle': 'Remove external status (it)',
      'removeExternalStatusMessage': 'Are you sure you want to remove \'{{ externalStatusName }}\' external status? (it)',
      'tooltipRemove': 'Remove (it)',
      'rightSideBar': {
        'title': 'DETAILS (it)',
      },
      'settingsModal': {
        'title': 'External Status Settings (it)',
      },
    },
    'ticketProvidersPage': {
      'importTicketProvider': 'Import Ticket Provider (it)',
      'pageHeader': 'Ticket Providers (it)',
      'addProvider': 'Add Provider (it)',
      'addNewProvider': 'Add New Ticket Provider (it)',
      'formFieldName': 'Name (it)',
      'formFieldProjectName': 'Project Name (it)',
      'formPlaceholderName': 'Enter Name (it)',
      'formPlaceholderProjectName': 'Enter Project Name (it)',
      'removeProviderTitle': 'Remove Ticket Provider (it)',
      'removeProviderMessage': 'Are you sure you want to remove the \'{{ticketProviderName}}\'  ticket provider? (it)',
      'cleanupTickets': 'Cleanup tickets (it)',
      'cleanupTicketsMessage': 'Are you sure you want to remove all tickets for selected ticket provider? (it)',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticketing systems (it)',
      'tableHeaderProviderName': 'ticket provider name (it)',
      'tableHeaderProviderType': 'type (it)',
      'tableHeaderProjectName': 'project name (it)',
      'tableHeaderTsCount': 'ticketing systems count (it)',
      'tableHeaderEndpoint': 'endpoint (it)',
      'tableHeaderStatusCollection': 'status collection (it)',
      'tableHeaderSharedMap': 'shared fields map (it)',
      'showQueriesTooltip': 'Show Queries (it)',
      'showProviderTicketBoardsTooltip': 'Show Ticket Boards (it)',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name (it)',
        'sectionProjectName': 'Project Name (it)',
        'sectionTCEndpoint': 'Endpoint (it)',
        'sectionTPType': 'Type (it)',
        'sectionUrl': 'URL (it)',
        'sectionClientId': 'Client Id (it)',
        'sectionUsername': 'User Name (it)',
        'sectionConnection': 'Connection (it)',
        'sectionAttachments': 'Attachments (it)',
        'sectionComments': 'Comments (it)',
        'sectionCloneTickets': 'Clone tickets (it)',
        'sectionAllowNewTickets': 'Create tickets (it)',
        'sectionStatusCollection': 'Status Collection (it)',
        'sectionStatusCollectionLinkTooltip': 'Open Status Collection (it)',
        'sectionSharedMap': 'Shared Fields Map (it)',
        'sectionSharedMapLinkTooltip': 'Open Shared Fields Map (it)',
        'sectionUsedBy': 'Used By (it)',
        'sectionUsedByTicketingSystem': 'Ticketing Systems (it)',
        'sectionLogo': 'Logo (it)',
        'sectionKinesisEnabled': 'Kinesis (it)',
        'sectionStreamName': 'Stream Name (it)',
        'sectionRegion': 'Region (it)',
        'sectionRole': 'Role (it)',
      },
      'connectionSettingsModal': {
        'title': 'Connection (it)',
        'providerType': 'Provider Type (it)',
        'settings': 'Settings (it)',
      },
      'settingsModal': {
        'title': '{{name}} Provider Settings (it)',
      },
    },
    'queriesPage': {
      'enqueueQuery': 'Perform Query (it)',
      'dryRunQuery': 'Dry Run Query (it)',
      'dryRunEmptyResult': 'Result is empty (it)',
      'dryRunQueryModalTitle': '\'{{queryName}}\' Query Dry Run Result (it)',
      'newPageHeader': 'Manage Queries (it)',
      'breadcrumbs': 'Queries (it)',
      'pageHeader': 'Queries for {{ type }} (it)',
      'addQuery': 'Add Query (it)',
      'addFormTitle': 'Add New Query (it)',
      'addFormQueryName': 'NAME (it)',
      'addFormQueryNamePlaceholder': 'name (it)',
      'addFormQueryBody': 'BODY (it)',
      'addFormQueryBodyPlaceholder': 'description (it)',
      'removeQueryTitle': 'Remove Query (it)',
      'removeQueryMessage': 'Are you sure you want to remove \'{{queryName}}\' query? (it)',
      'tableHeaderQueryName': 'query name (it)',
      'tableHeaderActive': 'active (it)',
      'tableHeaderExecPeriod': 'execution period (it)',
      'useToReloadTickets': 'Use to Reload Tickets (it)',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name (it)',
        'sectionQueryName': 'Name (it)',
        'sectionQueryBody': 'Body (it)',
        'sectionStartAt': 'Start At (it)',
        'sectionMaxResults': 'Max Results (it)',
        'sectionExecPeriod': 'Execution Period (it)',
        'sectionTicketProvider': 'Ticket Provider (it)',
        'sectionActive': 'Active (it)',
        'offsetTooltipText': 'Time Offset in Minutes (it)',
      },
      'settingsModal': {
        'title': 'Query Settings (it)',
      },
    },
    'providerTicketBoardsPage': {
      'newPageHeader': 'Manage Ticket Boards (it)',
      'breadcrumbs': 'Ticket Boards  (it)',
      'addTicketBoard': 'Add Ticket Board (it)',
      'addFormTitle': 'Add New Ticket Board (it)',
      'addFormTicketBoardName': 'NAME (it)',
      'addFormTicketBoardNamePlaceholder': 'name (it)',
      'addFormTicketBoardQuery': 'QUERY (it)',
      'addFormTicketBoardQueryPlaceholder': 'Query body (it)',
      'removeTicketBoardTitle': 'Remove Ticket Board (it)',
      'removeTicketBoardMessage': 'Are you sure you want to remove \'{{providerTicketBoardName}}\' ticket board? (it)',
      'tableHeaderTicketBoardName': 'Ticket Board Name (it)',
      'tableHeaderActive': 'active (it)',
      'tableHeaderDefault': 'default (it)',
      'tooltipEditTable': 'Edit Table (it)',
      'tooltipEditCsvExportTable': 'Edit CSV Export Table (it)',
      'rightSideBar': {
        'sectionProviderName': 'Ticket Provider Name (it)',
        'sectionTicketBoardName': 'Name (it)',
        'sectionTicketBoardQuery': 'Query (it)',
        'sectionActive': 'Active (it)',
        'sectionDefault': 'Default (it)',
        'sectionUsedBy': 'Used By (it)',
      },
      'settingsModal': {
        'title': 'Ticket Board Settings (it)',
      },
    },
    'csvExportTableEditPage': {
      'pageHeader': 'Edit Ticket CSV Export Table (it)',
    },
    'sharedFieldsMapsPage': {
      'pageHeader': 'Shared Fields Maps (it)',
      'importSharedFieldsMap': 'Import Shared Fields Map (it)',
      'addEntity': 'Add Shared Fields Map (it)',
      'addNewEntity': 'Add New Shared Fields Map (it)',
      'formFieldName': 'Name (it)',
      'sharedFieldsMapNamePlaceholder': 'Please enter Shared Fields Map name (it)',
      'removeEntity': 'Remove Shared Fields Map (it)',
      'removeEntityMessage': 'Are you sure you want to remove \'{{sharedFieldsMapName}}\' shared fields map? (it)',
      'manageColumns': 'Manage Columns (it)',
      'tableHeaderName': 'shared fields map name (it)',
      'rightSideBar': {
        'title': 'DETAILS (it)',
        'sectionSharedFieldsMapName': 'Shared Fields Map Name (it)',
        'sectionUsedBy': 'Used By (it)',
        'sectionUsedByTicketProvider': 'Ticket Provider (it)',
      },
      'settingsModal': {
        'title': 'Shared Fields Maps Settings (it)',
        'sectionUsedByTicketProvider': 'Ticket Providers (it)',
      },
    },
    'auditPage': {
      'actionsTitle': 'ACTIONS (it)',
      'actionCreate': 'Create action (it)',
      'actionUpdate': 'Update action (it)',
      'actionDestroy': 'Destroy action (it)',
      'tableHeader': 'Action (it)',
      'justificationTitle': 'Justification (it)',
      'sideBarTitle': 'CHANGES (it)',
      'actionsType': {
        'allPartnerActions': 'all_partner_actions (it)',
        'userActions': 'user_actions (it)',
        'integrationActions': 'integration_actions (it)',
        'adminActions': 'admin_actions (it)',
      },
      'auditable': {
        'auditableModels': 'Auditable models (it)',
        'ticketingSystemTicket': 'TicketingSystemTicket (it)',
        'providerTicket': 'ProviderTicket (it)',
        'providerComment': 'ProviderComment (it)',
        'providerAttachment': 'ProviderAttachment (it)',
        'subscription': 'Subscription (it)',
        'userFilter': 'UserFilter (it)',
        'provider': 'TicketProvider (it)',
        'partner': 'Partner (it)',
        'ts': 'TicketingSystem (it)',
        'tsColumn': 'BaseColumn (it)',
        'tsQuery': 'TicketingSystemQuery (it)',
        'statusCollection': 'StatusCollection (it)',
        'partnerStatus': 'PartnerStatus (it)',
        'externalStatus': 'ExternalStatus (it)',
        'providerCredential': 'ProviderCredential (it)',
        'attachmentMimeType': 'AttachmentMimeType (it)',
        'mimeTypeCollection': 'MimeTypeCollection (it)',
        'providerTicketBoard': 'ProviderTicketBoard (it)',
      },
    },
    'metaDataPages': {
      'adminSubscriptions': {
        'header': 'Subscriptions (it)',
        'filterBy': 'Filter by (it)',
        'filterPartnerLabel': 'All Partners (it)',
        'filterStatusesLabel': 'All Statuses (it)',
        'table': {
          'ticket': 'Ticket ID (it)',
          'subscribed': 'Subscribed by (it)',
          'userPartner': 'Partner (it)',
          'ticketStatus': 'Ticket Status (it)',
          'title': 'Title (it)',
          'ticketUpdated': 'Ticket Updated (it)',
          'subscriptionCreatedAt': 'Created At (it)',
          'userInfoTooltip': 'Name: {{subscriberName}}\nLogin: {{subscriberLogin}}\nEmail: {{subscriberEmail}} (it)',
        },
      },
      'userFiltersPage': {
        'header': 'User Filters (it)',
        'filterTypesPlaceholder': 'All Types (it)',
        'filterProviderLabel': 'All Providers (it)',
        'showFilter': 'Show Filters (it)',
        'filterPlaceholder': 'Filter name or user (it)',
        'table': {
          'name': 'Name (it)',
          'createdBy': 'Created by (it)',
          'query': 'Query (it)',
          'type': 'Type (it)',
          'partner': 'Partner (it)',
          'ts': 'Ticketing System (it)',
          'provider': 'Ticket Provider (it)',
          'providerTicketBoard': 'Provider Ticket Board (it)',
          'createdAt': 'Created At (it)',
          'userInfoTooltip': 'Name: {{userName}}\nLogin: {{userLogin}}\nEmail: {{userEmail}} (it)',
        },
        'filtersFound': '{{filtersCount}} filters found by: (it)',
      },
      'usersPage': {
        'header': 'Users (it)',
        'table': {
          'login': 'Login (it)',
          'firstName': 'First Name (it)',
          'lastName': 'Last Name (it)',
          'email': 'Email (it)',
          'capability': 'Сapability (it)',
          'partner': 'Partner (it)',
          'lastLogin': 'Last login (it)',
          'alertHeader': 'Remove User (it)',
          'alertText': 'Are you sure you want to remove \'{{ userName }}\' user? (it)',
        },
        'roles': {
          'admin': 'Admin (it)',
          'adminImpersonated': 'Admin Impersonated (it)',
          'adminReadOnly': 'Admin Read Only (it)',
          'adminReadOnlyImpersonated': 'Admin Read Only Impersonated (it)',
          'powerUser': 'Power User (it)',
          'powerUserImpersonated': 'Power User Impersonated (it)',
          'partner': 'Partner (it)',
        },
        'filterPanelTitle': 'Filters (it)',
        'filterPanelTitleTooltip': 'Click to open Filters sidebar (it)',
        'clearAllFiltersTooltip': 'Clear Filters (it)',
        'filterPanelFiltersTooltip': 'Active Filters (it)',
        'usersCount_one': '{{count}} user (it)',
        'usersCount_other': '{{count}} users (it)',
        'clearFilterTooltip': 'Clear "{{filterName}}" Filter (it)',
        'rightSideBar': {
          'header': 'User Details (it)',
          'sectionId': 'Id (it)',
          'sectionFirstName': 'First Name (it)',
          'sectionLastName': 'Last Name (it)',
          'sectionEmail': 'Email (it)',
          'sectionPartner': 'Partner (it)',
          'sectionRole': 'Role (it)',
          'sectionCapability': 'Capability (it)',
          'sectionTimezone': 'Time Zone (it)',
          'sectionLastVisitApiDoc': 'Last Visit of API Doc (it)',
          'sectionFirstLogin': 'First Login (it)',
          'sectionApiDocVisitCount': 'API Doc Visit Count (it)',
          'sectionLoginCount': 'Login Count (it)',
          'autosubscription': 'Autosubscription (it)',
        },
        'filters': {
          'partnerName': 'Partner (it)',
          'login': 'Login (it)',
          'email': 'Email (it)',
          'role': 'Role (it)',
          'capability': 'Сapability (it)',
          'timeZone': 'Time Zone (it)',
          'autosubscription': 'Autosubscription (it)',
          'firstLoginStartDate': 'First Login Start Time (it)',
          'firstLoginEndDate': 'First Login End Time (it)',
          'lastLoginStartDate': 'Last Login Start Time (it)',
          'lastLoginEndDate': 'Last Login End Time (it)',
          'visitApiStartDate': 'Last Visit of API Doc Start Time (it)',
          'visitApiEndDate': 'Last Visit of API Doc End Time (it)',
        },
      },
    },
    'partnerTicketingSystemsPage': {
      'pageHeader': 'Manage Ticketing Systems for {{partnerName}} (it)',
      'addTs': 'Add Ticketing System (it)',
      'addTsNew': 'Add New Ticketing System (it)',
      'importTs': 'Import Ticketing System (it)',
      'formFieldName': 'Name (it)',
      'tsNamePlaceholder': 'Please enter Ticketing System name (it)',
      'table': {
        'displayId': 'Display ID (it)',
        'removeTitle': 'Remove Ticketing System (it)',
        'removeText': 'Are you sure you want to remove \'{{ticketingSystemName}}\' ticketing system? (it)',
        'name': 'Name (it)',
        'tp': 'Ticket Provider (it)',
        'uiAccess': 'ui access (it)',
        'apiAccess': 'api access (it)',
        'allowNewTickets': 'create tickets  (it)',
        'attachments': 'attachments (it)',
        'comments': 'comments (it)',
        'manageColumns': 'Manage Columns (it)',
      },
      'rightSideBar': {
        'displayId': 'Display ID (it)',
        'tsName': 'Ticketing System Name (it)',
        'tp': 'Ticket Provider (it)',
        'tpLinkTooltip': 'Open Ticket Provider (it)',
        'statusCollection': 'Status Collection (it)',
        'statusCollectionLinkTooltip': 'Open Status Collection (it)',
        'uiAccess': 'UI Access (it)',
        'apiAccess': 'API Access (it)',
        'allowNewTickets': 'Create tickets (it)',
        'attachments': 'Attachments (it)',
        'comments': 'Comments (it)',
        'emailSettings': 'Email Settings (it)',
        'emailSettingsComment': 'Display Comment Details (it)',
        'emailSettingsAttachment': 'Display Attachment Details (it)',
        'publishInternalFields': 'Publish Internal Fields (it)',
        'usePtgwTimestamp': 'Use internal Relay timestamp for ticket filtering by default (it)',
        'ticketBonding': 'Ticket Bonding (it)',
        'manageUiAccess': 'UI Access management (it)',
        'addUiAccess': 'Add Role (it)',
        'editUiAccess': 'Edit Role (it)',
        'uiAccessIsEmpty': 'UI Access not configured (it)',
        'uiAccessRole': 'role (it)',
        'uiAccessRolePlaceholder': 'Please, enter user role (it)',
        'uiAccessAccessPlaceholder': 'Please, select UI Access (it)',
        'uiAccessAccess': 'Ui access (it)',
        'uiAccessRemoveTitle': 'Remove Role (it)',
        'uiAccessRemoveAlert': 'Are you sure you want to remove \'{{ roleName }}\' Role? (it)',
        'excludedPartnerStatuses': 'Excluded Partner Statuses (it)',
        'excludedPartnerStatusesTooltip': 'Unbonded tickets with selected partners statuses will be not displayed (it)',
      },
      'settingsModal': {
        'title': 'Ticketing System Settings (it)',
      },
    },
    'feedbackPage': {
      'pageHeader': 'Feedback (it)',
      'feedbacksFound': '{{feedbacksCount}} feedback found by: (it)',
      'filter': {
        'statusFilterPlaceholder': 'All Statuses (it)',
        'partnerFilterPlaceholder': 'All Partners (it)',
        'searchPlaceholder': 'search feedback... (it)',
      },
      'table': {
        'status': 'status (it)',
        'reference': 'reference (it)',
      },
      'sidebar': {
        'experience': 'experience (it)',
        'reference': 'reference (it)',
        'status': 'status (it)',
        'statusRejected': 'Rejected (it)',
        'statusApproved': 'Approved (it)',
        'notes': 'Notes (it)',
        'originLocation': 'Località di origine',
      },
    },
    'feedbackSidebarForm': {
      'title': 'Send us your feedback! (it)',
      'subtitle1': 'Do you have a suggestion or have found an issue? (it)',
      'subtitle2': 'Let the Relay team know. (it)',
      'experienceSectionTitle': 'How was your experience? (it)',
      'descSectionTitle': 'Describe your experience (it)',
      'buttonLabel': 'Send Feedback (it)',
      'menuButtonTooltip': 'Send Feedback (it)',
    },
    'signInPanel': {
      'title': 'Your Auth Provider (it)',
      'signIn': 'Sign In (it)',
    },
    'sandboxSignInPanel': {
      'name': 'Input Your Name (it)',
      'provider': 'Select Provider (it)',
      'role': 'Select Role (it)',
    },
    'ticketsSearchResultsPage': {
      'pageHeader': 'Search Results (it)',
      'moreLink': 'Show More (it)',
      'ticketsFound': '{{ticketsCount}} tickets found (it)',
    },
    'ticketProviderTicketsSearchResultsPage': {
      'pageHeader': 'Search Results (it)',
      'moreLink': 'Show More (it)',
      'ticketsFound': '{{ticketsCount}} tickets found (it)',
    },
    'welcomePage': {
      'greeting': 'Welcome (it)',
      'selectTS': 'Select a Ticketing System.... (it)',
    },
    'ticketTableEditPage': {
      'pageHeader': 'Edit Ticket Table (it)',
      'addColumns': 'Add Column(s) (it)',
      'editColumnList': 'Edit Column List (it)',
      'addNewColumns': 'Add New Column(s) (it)',
      'columns': 'Column(s) (it)',
      'columnName': 'Column Name (it)',
      'tooltipRemoveColumn': 'Remove Column (it)',
    },
    'ticketProviderTicketPage': {
      'tableNoData': 'no data (it)',
      'deleteTicketLink': 'Remove ticket (it)',
      'reloadTicketLink': 'Reload ticket (it)',
      'requestTicketLink': 'Show ticket requests (it)',
      'removeTicketTitle': 'Remove Ticket (it)',
      'removeTicketMessage': 'Please confirm that you want to remove ticket: {{number}}(it)',
      'commentsAll': 'All (it)',
      'commentsOnly': 'only (it)',
      'comments': 'Comments (it)',
      'commentsNo': 'No comments (it)',
      'attachments': 'Attachments (it)',
      'attachmentsNo': 'No attachments (it)',
      'attachmentsHeaderId': 'ID (it)',
      'attachmentsHeaderFilename': 'Filename (it)',
      'attachmentsHeaderOwner': 'Owner (it)',
      'attachmentsHeaderCreated': 'Created (it)',
      'attachmentsHeaderSize': 'Size (it)',
      'sidebarDetails': 'DETAILS (it)',
      'sidebarSectionTicketProvider': 'TICKET PROVIDER (it)',
      'sidebarSectionRelayId': 'Relay Ticket ID (it)',
      'sidebarSectionType': 'Type (it)',
      'sidebarSectionChildren': {
        'title': 'Children (it)',
        'columns': {
          'id': 'Ticket ID (it)',
          'title': 'Title (it)',
        },
      },
      'filteredBy': 'Filtered By (it)',
      'attachmentsFilter': {
        'partnersFilterPlaceholder': 'All Partners (it)',
        'extensionsFilterPlaceholder': 'All Types (it)',
        'searchPlaceholder': 'search attachments (it)',
        'filterPanelSearchTooltip': 'Click to Search (it)',
        'filterPanelClearSortingTooltip': 'Clear Sorting (it)',
        'sortFieldLabels': {
          'external_created_at': 'CREATED DATE (it)',
          'type': 'TYPE (it)',
          'size': 'SIZE (it)',
          'filename': 'FILE NAME (it)',
        },
      },
      'commentsFilter': {
        'partnersFilterPlaceholder': 'All Partners (it)',
        'authorsFilterPlaceholder': 'All Authors (it)',
        'searchPlaceholder': 'search comments (it)',
        'filterPanelSearchTooltip': 'Click to Search (it)',
        'filterPanelClearSortingTooltip': 'Clear Sorting (it)',
        'sortFieldLabel': 'CREATED DATE (it)',
      },
      'childrenSection': {
        'title': 'Children (it)',
      },
    },
    'ticketProviderTicketsPage': {
      'removeTicketsTitle': 'Remove Tickets (it)',
      'removeTicketsMessage_one': 'Please confirm that you want to remove {{count}} ticket: {{numbers}} (it)',
      'removeTicketsMessage_other': 'Please confirm that you want to remove {{count}} tickets: {{numbers}} (it)',
      'statusesFilterPlaceholder': 'All Statuses (it)',
      'searchPlaceholder': 'Search {{ticketProviderName}} tickets... (it)',
      'searchPlaceholderNew': 'search tickets (it)',
      'bulkRemoveLink': 'Bulk remove (it)',
      'removeTicketsLink': 'Remove selected tickets (it)',
      'reloadTicketsLink': 'Reload tickets (it)',
      'ticketsFound': '{{ticketsCount}} tickets found by: (it)',
      'ticketsCount_one': '{{count}} ticket (it)',
      'ticketsCount_other': '{{count}} tickets (it)',
      'sortedByPlaceholder': 'Choose Sorting Field (it)',
      'resetSortingTooltip': 'Reset to Default (it)',
      'sortDirectionTooltip': 'Reverse Sort Direction (it)',
      'sortRelayTicketIdLabel': 'Relay Ticket Id (it)',
      'clearFiltersLink': 'Clear All Filters (it)',
      'tableHeaderId': 'Ticket ID (it)',
      'tableHeaderPartnerId': 'Partner ID (it)',
      'tableHeaderOwner': 'Owner (it)',
      'tableHeaderStatus': 'Status (it)',
      'tableHeaderTitle': 'Title (it)',
      'tooltipMultiUserFilter': 'Multi-user filter (it)',
      'tooltipAdminOnlyFilter': 'Admin-only filter (it)',
      'tooltipPrivateFilter': 'Private filter (it)',
      'filters': 'Filters (it)',
      'removeFilterTitle': 'Remove Filter (it)',
      'removeFilterMessage': 'Are you sure you want to remove \'{{ filterName }}\'  filter? (it)',
      'tooltipChildTickets_one': 'This ticket contains {{childTicketsIds}} child (it)',
      'tooltipChildTickets_other': 'This ticket contains {{childTicketsIds}} children (it)',
      'tooltipChildTicketsMore': ' and {{count}} more (it)',
      'attachmentsCount_one': '{{count}} attachment (it)',
      'attachmentsCount_other': '{{count}} attachments (it)',
      'commentsCount_one': '{{count}} comment (it)',
      'commentsCount_other': '{{count}} comments (it)',
      'emptyFiltersText': 'No active filters available (it)',
      'createFilterTooltip': 'Create Filter (it)',
      'editFilterTooltip': 'Edit Filter (it)',
      'removeFilterTooltip': 'Remove Filter (it)',
      'filterPanelTitle': 'Tickets View (it)',
      'filterPanelTitleTooltip': 'Click to open Tickets View filter sidebar (it)',
      'filterPanelFiltersTooltip': 'Active Custom Filters (it)',
      'filterPanelClearFiltersTooltip': 'Clear Custom Filters (it)',
      'filterPanelClearStatusesTooltip': 'Clear Status Filters (it)',
      'filterPanelSearchTooltip': 'Click to Search (it)',
      'filterPanelClearSortingTooltip': 'Clear Sorting (it)',
      'filtersStatusSectionTitle': 'Statuses (it)',
      'filterForm': {
        'title': 'Filter Settings (it)',
        'generalInformation': 'General Information (it)',
        'conditions': 'Conditions (it)',
        'saveFilter': 'Save Filter (it)',
        'deleteFilter': 'Delete Filter (it)',
        'fieldLabelName': 'Name (it)',
        'fieldLabelVisibility': 'Visibility (it)',
        'visibilityPrivate': 'Private (it)',
        'visibilityAdmins': 'Admins (it)',
        'visibilityAllUsers': 'All Users (it)',
        'advancedMode': 'Advanced mode (it)',
        'addNewCondition': 'Add New Condition (it)',
        'advancedTooltip':
          'Operators: LIKE, NOT_LIKE, EQUAL, NOT_EQUAL, IN, NOT_IN, EMPTY, NOT_EMPTY\n' +
          'Keywords: AND, OR\n\n' +
          'Example:\n' +
          'title LIKE "test" OR severity IN 5,4,3 (it)',
        'resultExpression': 'Result Expression (it)',
        'resultExpressionText': 'Show when {{- query}} (it)',
        'table': {
          'field': 'field (it)',
          'operator': 'operator (it)',
          'value': 'value (it)',
        },
        'allFieldsLabel': 'Ticket Fields (it)',
        'dynamicFieldsLabel': 'Dynamic Options (it)',
        'selectFieldPlaceholder': 'select field (it)',
        'selectOperatorPlaceholder': 'select operator (it)',
        'selectValuePlaceholder': 'select value (it)',
        'optionLabels': {
          'is_me': 'Is Me (it)',
          'my_company': 'My Company (it)',
        },
        'removeConditionTooltip': 'Remove Condition (it)',
      },
    },
    'ticketProvidersListPage': {
      'greeting': 'Welcome (it)',
      'selectTicketProvider': 'Select a Ticket Provider... (it)',
    },
    'scrollableTabsPanel': {
      'noTicketingSystems': 'There is no Ticketing Systems by this Provider (it)',
      'provider': 'Provider (it)',
    },
    'partnerOauthAppsPage': {
      'pageHeader': 'Manage Oauth Applications (it)',
      'newApplication': 'New Application (it)',
      'removeAppTitle': 'Remove Oauth Application (it)',
      'removeAppMessage': 'Are you sure you want to remove \'{{ oauthAppName }}\' Oauth Application? (it)',
      'addNewApp': 'Add New Application (it)',
      'nameLabel': 'name (it)',
      'expiresIn': 'Token Expires In (it)',
      'expiresInTooltip': 'Token TTL in seconds (it)',
      'secretModal': {
        'title': '{{name}} Secret (it)',
        'notification': 'The Secret is only visible once here. You can copy it for further use. (it)',
        'copyButton': 'Copy Secret (it)',
        'secret': 'secret (it)',
        'copiedTooltip': 'Secret copied to clipboard (it)',
      },
      'table': {
        'name': 'Name (it)',
        'createdAt': 'Created At (it)',
      },
    },
    'mimeTypeCollectionsPage': {
      'pageHeader': 'Mime Type Collections (it)',
      'addEntity': 'Add Mime Type Collection (it)',
      'tableHeaderName': 'Mime Type Collection Name (it)',
      'manageMimeTypes': 'Manage Mime Types (it)',
      'formFieldName': 'Name (it)',
      'namePlaceholder': 'Please enter Mime Type Collection name (it)',
      'rightSideBar': {
        'title': 'DETAILS (it)',
        'sectionUsedBy': 'Used By (it)',
        'sectionUsedByTicketProvider': 'Ticket Providers (it)',
      },
      'settingsModal': {
        'title': 'Mime Type Collection Settings (it)',
      },
      'removeEntity': 'Remove Mime Type Collection (it)',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- mimeTypeCollectionName }}\' mime type collection? (it)',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticket providers (it)',
    },
    'mimeTypeCollectionPage': {
      'importMimeTypeCollection': 'Import Mime Type Collection (it)',
      'pageHeader': 'Mime Type Collection (it)',
      'addEntity': 'Add Mime Type (it)',
      'tableHeaderName': 'Mime Type Name (it)',
      'formFieldName': 'Name (it)',
      'namePlaceholder': 'Please enter Mime Type name (it)',
      'rightSideBar': {
        'title': 'DETAILS (it)',
      },
      'settingsModal': {
        'title': 'Mime Type Settings (it)',
      },
      'removeEntity': 'Remove Mime Type (it)',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- mimeType }}\' mime type? (it)',
    },
    'webhookEventsPage': {
      'header': 'Webhook Events (it)',
      'webhookEventsCount_one': '{{count}} webhook event (it)',
      'webhookEventsCount_other': '{{count}} webhooks events (it)',
      'executeWebhookTooltip': 'Execute Webhook Event (it)',
      'markAsIgnoredTooltip': 'Mark as ignored (it)',
      'redirectToRequestsTooltip': 'Requests for Webhook (it)',
      'retryEventsLink': 'Riprova gli eventi non riusciti',
      'retryFailedEventsValue': 'Riprova gli eventi webhook non riusciti',
      'retryFailedEventsValueText': 'Conferma di voler riprovare {{count}} evento/i webhook per {{numbers}} ticket?',
      'filterPanelTitle': 'Filters (italiano)',
      'filterPanelTitleTooltip': 'Click to open Filter sidebar (italiano)',
      'filterPanelFiltersTooltip': 'Active Filters (italiano)',
      'clearAllFiltersTootltip': 'Clear Filters (italiano)',
      'clearFilterTooltip': 'Clear "{{filterName}}" Filter (italiano)',
      'filters': {
        'ticketNumber': 'Ticket ID (it)',
        'action': 'Action (it)',
        'state': 'State (it)',
        'correlationId': 'Correlation ID (it)',
        'externalEventId': 'External Event ID (it)',
        'webhookId': 'Webhook ID (it)',
        'entitySysId': 'Entity Sys ID (it)',
        'webhookParams': 'Webhook Params (it)',
        'executedStartDate': 'Last Executed At Start Date (it)',
        'executedEndDate': 'Last Executed At End Date (it)',
        'allStates': 'all states (it)',
        'allActions': 'all actions (it)',
        'statePending': 'pending (it)',
        'stateProcessing': 'processing (it)',
        'stateSuccessful': 'successful (it)',
        'stateFailed': 'failed (it)',
        'stateInRetry': 'in retry (it)',
        'stateDuplicate': 'duplicate (it)',
        'stateIgnored': 'ignored (it)',
        'actionTypeUnknown': 'unknown (it)',
        'actionTypeCreateTicket': 'create ticket (it)',
        'actionTypeUpdateTicket': 'update ticket (it)',
        'actionTypeCreateComment': 'create comment (it)',
        'actionTypeCreateAttachment': 'create attachment (it)',
      },
      'search': {
        'placeholder': 'Type ticket number (it)',
      },
      'table': {
        'headerId': 'Id (it)',
        'headerTicketId': 'Ticket Id (it)',
        'headerActionType': 'Action (it)',
        'headerState': 'State (it)',
        'headerCtn': 'Ctn (it)',
        'headerCreatedAt': 'Created At (it)',
        'headerLastExecutedAt': 'Last executed at (it)',
        'headerRequestCount': 'Request Count (it)',
      },
      'rightSideBar': {
        'header': 'Webhook Event Details (it)',
        'sectionId': 'Id (it)',
        'sectionState': 'State (it)',
        'sectionTicketId': 'Ticket Id (it)',
        'sectionParams': 'Webhook Params (it)',
        'sectionCreatedAt': 'Created At (it)',
        'sectionLastExecutedAt': 'Last executed at (it)',
        'sectionRequestCount': 'Request Count (it)',
        'externalEventId': 'External Event Id (it)',
        'sectionCtn': 'Ctn (it)',
        'entitySysId': 'Entity sys Id (it)',
        'correlationID': 'Correlation Id (it)',
        'lastResponsePayload': 'last Response Payload (it)',
        'errorMessage': 'Error Message (it)',
      },
    },
    'satCompliance': {
      'compliant': 'Compliant (it)',
      'soonOutOfCompliance': 'Soon Out of Compliance (it)',
      'outOfCompliance': 'Out of Compliance (it)',
      'notUsed': 'Not Used (it)',
      'disabled': 'Disabled (it)',
    },
    'satClientsPage': {
      'pageHeader': 'SAT Clients (it)',
      'syncClients': 'Sync SAT Clients (it)',
      'clientsCount': '{{count}} SAT Clients (it)',
      'filterPanelTitle': 'Filters (it)',
      'filterPanelTitleTooltip': 'Click to open Filters sidebar (it)',
      'filterPanelFiltersTooltip': 'Active Filters (it)',
      'clearAllFiltersTooltip': 'Clear Filters (it)',
      'clearFilterTooltip': 'Clear "{{filterName}}" Filter (it)',
      'filters': {
        'clientId': 'SAT Client ID (it)',
        'capabilities': 'Capabilities (it)',
        'partner': 'Partner (it)',
        'enabled': 'Enabled (it)',
        'approved': 'Approved (it)',
        'compliance': 'Compliance (it)',
        'expiresAtStartDate': 'Expires At Start Time (it)',
        'expiresAtEndDate': 'Expires At End Time (it)',
        'lastUsedAtStartDate': 'Last Used At Start Time (it)',
        'lastUsedAtEndDate': 'Last Used At End Time (it)',
      },
      'table': {
        'id': 'ID (it)',
        'clientID': 'Client ID (it)',
        'partner': 'Partner (it)',
        'enabled': 'Enabled (it)',
        'approved': 'Approved (it)',
        'capabilities': 'Capabilities (it)',
        'compliance': 'Compliance (it)',
        'openSatSecretsTooltip': 'Manage SAT Secrets (it)',
        'openManagersModalTooltip': 'Open Managers (it)',
      },
      'rightSideBar': {
        'header': 'SAT Client Details (it)',
        'sectionClientId': 'Client ID (it)',
        'sectionCompliance': 'Compliance (it)',
        'sectionPartner': 'Partner (it)',
        'sectionDescription': 'Description (it)',
        'sectionCapabilities': 'Capabilities (it)',
        'sectionEnabled': 'Enabled (it)',
        'sectionApproved': 'Approved (it)',
        'sectionManagers': 'Managers (it)',
        'sectionCreatedAt': 'Created At (it)',
        'sectionUpdatedAt': 'Updated At (it)',
        'sectionSecrets': 'Secrets (it)',
        'secretsColumns': {
          'lastFour': 'Last Four (it)',
          'active': 'Active (it)',
          'expiresAt': 'Expires At (it)',
          'compliance': 'Compliance (it)',
        },
      },
      'managersModal': {
        'title': 'Set Managers (it)',
        'label': 'Manager List (it)',
        'placeholder': 'Enter user login or email (it)',
      },
    },
    'satSecretsPage': {
      'pageHeader': 'SAT Secrets (it)',
      'addSecret': 'Add New Secret (it)',
      'addConfirmDialogTitle': 'Confirm (it)',
      'addConfirmDialogMsg': 'Are you sure you want to generate a new secret? This will take effect immediately! (it)',
      'table': {
        'lastFour': 'Last Four (it)',
        'active': 'Active (it)',
        'compliance': 'Compliance (it)',
        'expiresAt': 'Expires At (it)',
        'lastUsedAt': 'Last Used At (it)',
        'disableSecretTooltip': 'Mark as disabled (it)',
        'disableConfirmDialogTitle': 'Confirm Disabling of Client Secret (it)',
        'disableConfirmDialogMsg': 'Are you sure you want to disable the secret? (it)',
      },
      'secretModal': {
        'title': 'New Secret Generated (it)',
        'notification': 'The Secret is only visible once here. You can copy it for further use. (it)',
        'copyButton': 'Copy Secret (it)',
        'copiedTooltip': 'Secret copied to clipboard (it)',
      },
    },
    'providerCredentialsPage': {
      'pageHeader': 'Provider Credentials (it)',
      'addEntity': 'Add Provider Credential (it)',
      'tableHeader': {
        'name': 'Name (it)',
        'credentialType': 'Credential Type (it)',
        'autorotation': 'Autorotate Secrets (it)',
        'nextRotationDate': 'Next Rotation Date (it)',
      },
      'formFieldName': 'Name (it)',
      'namePlaceholder': 'Please enter Provider Credential name (it)',
      'formFieldCredentialType': 'Credential Type (it)',
      'credentialTypePlaceholder': 'Please select Credential Type (it)',
      'rightSideBar': {
        'title': 'DETAILS (it)',
        'sectionUsedBy': 'Used By (it)',
        'sectionUsedByTicketProvider': 'Ticket Providers (it)',
      },
      'settingsModal': {
        'title': 'Provider Credential Settings (it)',
      },
      'removeEntity': 'Remove Provider Credential (it)',
      'removeEntityMessage': 'Are you sure you want to remove \'{{- providerCredentialName }}\' Provider Credential? (it)',
      'hintCannotBeRemoved': 'Cannot be removed while it is used for ticket providers (it)',
    },
    'confirmDialog': {
      'justificationLabel': 'Justification: (it)',
      'justificationPlaceholder': 'Enter justification here (it)',
    },
  },
}

export default it
